import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '..';
import {
  CreateDepartmentProps,
  DepartmentApiRes,
  DepartmentByIdResProps,
  UpdateDepartmentProps,
} from 'models/departments';

export const DepartmentsApi = createApi({
  reducerPath: 'DepartmentsApi',
  tagTypes: ['departments', 'department'],
  baseQuery,
  endpoints: (builder) => ({
    getDepartments: builder.query<DepartmentApiRes, string>({
      query: (url) => ({
        url: url,
      }),
      providesTags: ['departments'],
    }),
    createDepartment: builder.mutation<void, CreateDepartmentProps>({
      query: ({ url, ...props }) => ({
        url: url,
        method: 'POST',
        body: props,
      }),
      invalidatesTags: ['departments'],
    }),
    getDepartmentById: builder.query<DepartmentByIdResProps, string>({
      query: (url) => ({
        url: url,
      }),
      providesTags: ['department'],
    }),
    updateDepartment: builder.mutation<void, UpdateDepartmentProps>({
      query: ({ url, ...props }) => ({
        url: url,
        method: 'PATCH',
        body: props,
      }),
      invalidatesTags: ['departments', 'department'],
    }),
  }),
});

export const {
  useGetDepartmentsQuery,
  useCreateDepartmentMutation,
  useGetDepartmentByIdQuery,
  useUpdateDepartmentMutation,
} = DepartmentsApi;
